import { SHOW_BAG_BANNER, BAG_BANNER_SHOWN } from "./constants";

import get from "lodash/get";

import { bagCheckoutMVTPath } from "@template/state/middleware/infoBanner/validPath";

export { SHOW_BAG_BANNER, BAG_BANNER_SHOWN } from "./constants";

export { bagBannerShown } from "./actions";

export { getShowBagBanner, getBannerType } from "./selectors";

export const getBagCheckoutPromptMVTStatus = state =>
  bagCheckoutMVTPath() &&
  get(state, `features["emf-126-mweb-bag-checkout-prompt"]`);

const initialState = {
  showBagBanner: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_BAG_BANNER:
      return {
        ...state,
        showBagBanner: true,
        bannerType: action.bannerType
      };
    case BAG_BANNER_SHOWN:
      return {
        ...state,
        showBagBanner: false
      };
    default:
      return state;
  }
};

export default reducer;
